export {
	Modal,
	ModalBody,
	ModalClose,
	ModalDescription,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTrigger,
	ModalHeaderTemplate,
	ModalFooterTemplate,
} from "ics-ui-kit/components/modal";

export { ModalContent } from "./ModalContent";

export { isFromModal } from "./utils";
